// extracted by mini-css-extract-plugin
export var centerText = "_d6-8";
export var container = "_d6-0";
export var doughnutContainer = "_d6-7";
export var legend = "_d6-a";
export var legendItemColorDisplay = "_d6-b";
export var legendItemLabel = "_d6-d";
export var legendItemValue = "_d6-c";
export var lg = "_d6-5";
export var maxWidth = "_d6-9";
export var md = "_d6-4";
export var responsive = "_d6-6";
export var sm = "_d6-3";
export var xs = "_d6-2";
export var xxs = "_d6-1";